export default __webpack_public_path__ + "static/media/R7koritu.043486c0.mp3";